import React from 'react';
import { LocationPage } from './useLocationPage';
import './useLocationPage.css';

// ─── Images ───────────────────────────────────────────────────────────────────
// Swap out any of these for Sarasota-specific shots
import heroImg   from '../images/tampa3.webp';
import bgImg     from '../images/image8.webp';
import slideImg1 from '../images/image121.webp';
import slideImg2 from '../images/image117.webp';
import slideImg3 from '../images/image50.webp';

// ─── Config ───────────────────────────────────────────────────────────────────
const stPeteBeachConfig = {

  /* ── SEO ────────────────────────────────────────────────────────────────── */
  pageTitle:       'St. Pete Beach Tree Service | Sam\'s Tree Service',
  metaDescription: 'Professional tree trimming and removal in St. Pete Beach, FL. Sam\'s Tree Service handles dangerous coastal trees safely and affordably.',
  canonicalUrl:    'https://samstreeservice.com/tree_service_st_pete_beach',

  /* ── Hero ───────────────────────────────────────────────────────────────── */
  heroHeading: 'Serving St. Pete Beach',
  heroImageUrl: heroImg,
  bgImageUrl:   bgImg,

  /* ── Slide images ───────────────────────────────────────────────────────── */
  slideImage1: slideImg1,
  slideImage2: slideImg2,
  slideImage3: slideImg3,

  /* ── Main text panel ────────────────────────────────────────────────────── */
  sectionHeading: 'Professional Tree Service in St. Pete Beach Specializing In Dangerous Trees',

  paragraphs: [
    `At <strong>Sam's Tree Service</strong>, we handle the demanding tree work that 
     comes with owning property in <strong>St. Pete Beach</strong>. One of Florida's 
     most popular Gulf Coast destinations, this barrier island community sees relentless 
     salt air exposure and direct storm impact that accelerates tree decay and creates 
     serious hazards for homes, vacation rentals, and commercial properties alike. 
     Our team knows coastal tree work and handles it right.`,

    `We specialize in <strong>hazardous coastal tree removal and trimming</strong> 
     salt weakened trunks, wind stressed palms leaning toward structures, overgrown 
     canopies near rental properties and rooftops, and storm split limbs that need 
     immediate attention. We respond quickly and work cleanly on every job.`,

    `<strong>Sam's Tree Service</strong> provides expert, affordable tree care 
     throughout <strong>St. Pete Beach</strong> and the surrounding <strong>South 
     Pinellas barrier island</strong> communities so your property stays protected 
     and guest ready all year long.`,
  ],
  ctaLabel: 'Request An Appointment',

  /* ── Service buttons (optional — defaults to the 4 standard ones) ────────── */
  // serviceButtons: [
  //   { label: 'Tree Trimming', to: '/tree_trimming' },
  //   { label: 'Tree Removal',  to: '/tree_removal'  },
  //   { label: 'Stump Removal', to: '/stump_removal'  },
  //   { label: 'Debris Hauling',to: '/debris_hauling' },
  // ],

  /* ── Google Map ─────────────────────────────────────────────────────────── */
  mapCity: 'St. Pete Beach, FL',
};

// ─── Page ─────────────────────────────────────────────────────────────────────
const Services_StPeteBeach = () => <LocationPage config={stPeteBeachConfig} />;
export default Services_StPeteBeach;
